import { chain, capitalize, filter } from 'lodash';
import { useMemo } from 'react';
import { groupBySafe } from '@varos/util-typescript';
import { SourceListLoader } from './sourceListInterface';

export function createSourceListLoader(): SourceListLoader {
    return {
        useLoad(context, props) {
            const facets = useMemo(() => {
                const grouped = groupBySafe(
                    props.item.items,
                    (item) => item.root.original.type
                );
                return chain([
                    ...Object.entries(grouped).flatMap(([type, items]) => {
                        if (!items) {
                            return [];
                        }
                        return [
                            {
                                id: type,
                                label: capitalize(type),
                                count: items.length,
                            },
                        ];
                    }),
                ])
                    .orderBy((item) => item.count, 'desc')
                    .value();
            }, [props.item.items]);

            const items = useMemo(() => {
                return (
                    chain(props.item.items)
                        // .filter((item) => props.type === null || item.root.original.type === props.type)
                        .orderBy((item) => item.mentions.length, 'desc')
                        .value()
                );
            }, [props.item.items]);

            return {
                items: items,
                facets,
                counts: {
                    total: props.item.items.length,
                },
            };
        },
    };
}
